<script>
import debounce from "debounce";
import { isConsultationOptionsCNCEnabled } from "@/services/config";
import {
  CONSULTATION_OPTIONS,
  CONSULTATION_OPTIONS_CNC,
} from "@/services/constants";

export default {
  name: "ConsultationSelect",
  props: {
    value: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterValue: "",
    };
  },
  computed: {
    filteredOptions() {
      const options = isConsultationOptionsCNCEnabled
        ? CONSULTATION_OPTIONS_CNC
        : CONSULTATION_OPTIONS;
      if (!this.filterValue) {
        return options;
      }
      return options.filter((option) =>
        option.toLowerCase().includes(this.filterValue.toLowerCase())
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        const options = isConsultationOptionsCNCEnabled
          ? CONSULTATION_OPTIONS_CNC
          : CONSULTATION_OPTIONS;
        if (!newVal) {
          this.$emit("input", options[0]);
        }
      },
    },
  },

  methods: {
    onVisibleChange(visible) {
      if (visible) {
        this.filterValue = "";
      }
    },

    filterOptions: debounce(function (filterValue) {
      this.filterValue = filterValue;
    }, 300),
  },
};
</script>

<template lang="pug">
div
  el-select(
    :value="value"
    placeholder="Seleccionar tipo"
    :disabled="isDisabled"
    @input="$emit('input', $event)"
    @visible-change="onVisibleChange"
    filterable
    :filter-method="filterOptions"
  )
    el-option(
      v-for="opt in filteredOptions"
      :key="opt"
      :label="opt"
      :value="opt"
    )
</template>

<style scoped>
.label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
}
</style>
